import { OPEN_DIALOG, HIDE_DIALOG } from '../constants/action_types';

const initialState = [];

export default function (state = initialState, action) {
    switch (action.type) {
        case OPEN_DIALOG:
            return state.concat({ modalType: action.modalType, modalOpen: true, modalProps: action.modalProps, dialogid: action.dialogid, disableBackdrop: action.disableBackdrop, maxWidth: action.maxWidth });

        case HIDE_DIALOG:
            const newState = state.slice();
            newState.pop();
            return newState;

        default:
            return state
    }
}